export default "__VITE_ASSET__RkpcI$8i__"